var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{attrs:{"rules":_vm.rules,"name":_vm.veeName},scopedSlots:_vm._u([{key:"default",fn:function(validationContext){return [_c('div',{attrs:{"id":"feelline-base-select"}},[_c('CSelect',_vm._g(_vm._b(_vm._b({ref:"select",attrs:{"invalid-feedback":validationContext.errors[0],"options":_vm.options,"readonly":_vm.readonly},scopedSlots:_vm._u([_vm._l(([
          'prepend',
          'prepend-content',
          'append-content',
          'append',
          'label-after-input',
          'valid-feedback',
          'invalid-feedback',
          'description' ]),function(slot){return {key:slot,fn:function(){return [_vm._t(slot)]},proxy:true}})],null,true)},"CSelect",_vm._d({},[_vm.isValidate,_vm.getValidationState(validationContext)])),'CSelect',_vm.$attrs,false),_vm.$listeners))],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }